import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Work from "./pages/Work";
import Writing from "./pages/Writing";
import "./style.css";

// pdf.js and its worker are large; keep them out of the main bundle.
const Resume = lazy(() => import("./pages/Resume"));

function RouteFallback() {
  return (
    <div className="page">
      <div className="container">
        <p className="resume__fallback">Loading…</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Navbar />
        <main className="app__main">
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/work" element={<Work />} />
              <Route path="/writing" element={<Writing />} />
              <Route path="/resume" element={<Resume />} />

              {/* Legacy routes from the previous five-page layout. */}
              <Route
                path="/about"
                element={<Navigate to="/#about" replace />}
              />
              <Route
                path="/project"
                element={<Navigate to="/work" replace />}
              />
              <Route
                path="/blogs"
                element={<Navigate to="/writing" replace />}
              />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
